import { Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Pages } from '../routing/pages';

const menuItems = [
  {
    key: Pages.HOME.link,
    label: Pages.HOME.label,
  },
  {
    key: Pages.POSITIONS.link,
    label: Pages.POSITIONS.label,
  },
  {
    key: Pages.BENCHMARKS.link,
    label: Pages.BENCHMARKS.label,
  },
  // {
  //   key: Pages.JOB_DESCRIPTIONS.link,
  //   label: Pages.JOB_DESCRIPTIONS.label,
  // },
  {
    key: Pages.CONFIGURATION.link,
    label: Pages.CONFIGURATION.label,
  },
  {
    key: Pages.TASKS.link,
    label: Pages.TASKS.label,
  },
];

interface TopNavigationProps {
  selectedKey?: string;
}

export const TopNavigation = ({ selectedKey }: TopNavigationProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const activeKey = selectedKey ?? location.pathname;

  return (
    <Menu
      mode='horizontal'
      selectedKeys={[activeKey]}
      items={menuItems}
      onClick={handleMenuClick}
      className='flex-1 justify-center border-b-0'
    />
  );
};
